import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';

/**
 * The place card designer lives in the Dining app (shared Firebase auth).
 * This route exists so dashboard links do not fall through to "*" and send users to /login.
 */
export default function PlaceCardTemplatesRedirect(): JSX.Element {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const base = import.meta.env.VITE_DINING_URL?.replace(/\/$/, '') || 'http://localhost:3000';
    const target = `${base}/admin/place-card-templates`;
    try {
      window.location.replace(target);
    } catch {
      setError('Could not open the editor. Open the Dining app and sign in, then use Platform place cards from the menu.');
    }
  }, []);

  if (error) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-2 p-6 text-center text-sm text-muted-foreground">
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground">Opening place card template editor…</p>
    </div>
  );
}
